import type {Mapper} from 'framework';
import type {ScheduleWeekSlot} from '../../domain/schedule-week-slot';
import type {ScheduleWeekSlotDto} from '../dto/schedule.dto';

/** Pure shape copy of an open pattern slot as the week editor reads it. */
export class ScheduleWeekSlotDtoToScheduleWeekSlotMapper implements Mapper<
  ScheduleWeekSlotDto,
  ScheduleWeekSlot
> {
  transform(dto: ScheduleWeekSlotDto): ScheduleWeekSlot {
    return {
      id: dto.id,
      weekday: dto.weekday,
      position: dto.position,
      templateId: dto.templateId,
      templateName: dto.templateName,
      templateDeleted: dto.templateDeleted,
    };
  }
}
